import { guidValidationRegex } from './regex';

export function isValidGuid(guid: string): boolean {
  const match = guidValidationRegex.exec(guid);
  return match != null;
}
